import { Injectable, inject } from '@angular/core';
import { LernformKey } from '../../../../model/aggregations';
import { orderedVorortLernformen } from '../../../../model/lernformen';
import { LernformFacettenService } from './lernformfacetten.service';
import { LernformUrlService } from './lernformurl.service';

@Injectable({ providedIn: 'root' })
export class VorortLernformService extends LernformFacettenService {
  static identifier: LernformKey = LernformKey.Vorort;

  constructor() {
    const lernformUrlService = inject(LernformUrlService);

    super(lernformUrlService, VorortLernformService.identifier, orderedVorortLernformen);
  }
}
